import { FC } from 'react';

import { useI18nContext } from '../../hooks/contexts/i18n.context';
import { PriceComparison } from '../../hooks/contexts/resale-listing.pricing';
import * as Style from './styles';

const LABEL_KEYS: Record<PriceComparison, string> = {
  below : 'BELOW',
  equal : 'EQUAL',
  above : 'ABOVE',
};

type ResalePriceBadgeProps = {
  /** Comparison from the backend. `null`/missing = no original price: renders nothing. */
  comparison?: PriceComparison | null;
  id?: string;
  className?: string;
};

/**
 * Pill comparing the resale price (excluding fees) with the ticket type's original
 * price (Procon requirement). Color reinforces it, but the text carries the meaning.
 */
const ResalePriceBadge: FC<ResalePriceBadgeProps> = ({ comparison, id, className }) => {
  const { translate } = useI18nContext();
  if (!comparison) return null;

  return (
    <Style.Badge $variant={comparison} id={id} className={className} data-variant={comparison}>
      {translate(['RESALE_LISTING', 'PRICE_BADGE', LABEL_KEYS[comparison]])}
    </Style.Badge>
  );
};

export { ResalePriceBadge };
